import {
    REPORT_PATH_SEGMENTS,
    REPORTING_ROUTE,
} from "@components/reporting/reportingRoutes";
import { SCHEDULE_HUB_SCOPES } from "@components/accounting/schedules/scheduleHubScope";
import { ACCOUNTING_SUBSECTION_PATHS } from "../accountingNavigation";
import type { SideNavSectionRoutes } from "./useSideNavSections";

export const INTERCOMPANY_PATH = "/accounting/intercompany-transactions";
/** The reports catalog when the `/reporting` page is off (no consolidation). */
export const ACCOUNTING_REPORTS_PATH = "/accounting";

const withSubPaths = (path: string) => `${path}/*`;

/** Workspace nav sections, in order, with the routes that reopen each one. */
export const WORKSPACE_SIDE_NAV_SECTIONS = [
    {
        label: "Data",
        paths: [
            "/accounts",
            "/transactions",
            "/categories",
            "/documents",
            "/document-categories",
            "/ownership",
        ].map(withSubPaths),
    },
    {
        label: "Reports",
        paths: [
            ACCOUNTING_REPORTS_PATH,
            ...[
                "/insights",
                REPORTING_ROUTE,
                ...REPORT_PATH_SEGMENTS.map(
                    (segment) => `/accounting/${segment}`,
                ),
            ].map(withSubPaths),
        ],
    },
    {
        label: "Accounting",
        paths: [
            ...ACCOUNTING_SUBSECTION_PATHS,
            ...SCHEDULE_HUB_SCOPES.map((scope) => scope.path),
            INTERCOMPANY_PATH,
        ].map(withSubPaths),
        isCollapsedByDefault: true,
    },
    { label: "Automation", paths: ["/rules/*"], isCollapsedByDefault: true },
    {
        label: "Payments",
        paths: ["/invoicing/*", "/billing/*"],
        isCollapsedByDefault: true,
    },
] satisfies readonly SideNavSectionRoutes[];
